import React, { ReactNode, createContext, useContext, useMemo } from 'react';

import { ConsolidatedForecastsView } from '@futrli/views/ConsolidatedForecastsView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { ForecastKindOption } from '../types';
import { useCreateConsolidatedForecastForm } from '../hooks/useCreateConsolidatedForecastForm';
import { useOrgRouteParams } from '../../../hooks/useOrgRouteParams/useOrgRouteParams';

interface CreateConsolidatedForecastWizardContextProps {
  children?: ReactNode;
  kind: ForecastKindOption;
}

interface CreateConsolidatedForecastWizardContextValues {
  consolidationId: string;
  form: ReturnType<typeof useCreateConsolidatedForecastForm>;
  kind: ForecastKindOption;
  view: ConsolidatedForecastsView;
  workspaceId: string;
}

const defaultState = ({} as unknown) as CreateConsolidatedForecastWizardContextValues;
export const CreateConsolidatedForecastWizardContext = createContext(defaultState);

export const CreateConsolidatedForecastWizardContextProvider = ({
  children,
  kind
}: CreateConsolidatedForecastWizardContextProps) => {
  const { workspaceId, organisationId: consolidationId } = useOrgRouteParams();

  const view = useApiView(
    useMemo(() => new ConsolidatedForecastsView(workspaceId, consolidationId), [workspaceId, consolidationId])
  );
  const { createConsolidatedForecast } = view;
  const { consolidatedForecasts, subEntityForecasts } = view.state;

  const form = useCreateConsolidatedForecastForm(kind);

  const values = {
    consolidatedForecasts,
    consolidationId,
    createConsolidatedForecast,
    form,
    kind,
    subEntityForecasts,
    view,
    workspaceId
  };

  return (
    <CreateConsolidatedForecastWizardContext.Provider value={values}>
      {children}
    </CreateConsolidatedForecastWizardContext.Provider>
  );
};

export const useCreateConsolidatedForecastWizardContext = () => useContext(CreateConsolidatedForecastWizardContext);
